// removed by extract-text-webpack-plugin
module.exports = {"star-rating":"StarRating__star-rating","starRating":"StarRating__star-rating","star-rating-elements":"StarRating__star-rating-elements","starRatingElements":"StarRating__star-rating-elements","span-b":"StarRating__span-b","spanB":"StarRating__span-b","span-a":"StarRating__span-a","spanA":"StarRating__span-a","span-c":"StarRating__span-c","spanC":"StarRating__span-c","star-rating-focus-a":"StarRating__star-rating-focus-a","starRatingFocusA":"StarRating__star-rating-focus-a","star-rating-focus-b":"StarRating__star-rating-focus-b","starRatingFocusB":"StarRating__star-rating-focus-b"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StarRating/StarRating.scss
// module id = 1814
// module chunks = 8